module.exports = __webpack_public_path__ + "img/goods2_2.1a65819b.jpg";